import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LocationRequiredPageRoutingModule } from './location-required-routing.module';

import { LocationRequiredPage } from './location-required.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, LocationRequiredPageRoutingModule, TranslateModule.forChild()],
  declarations: [LocationRequiredPage]
})
export class LocationRequiredPageModule {}
